import React from 'react';
import { PiletDataApi } from 'settings/sdk/piralTypes';
import { createPiletUserSettingsApi, PiletUserSettingsApi } from '../sdk';

export type UserSettingsContextType = {
	api: PiletUserSettingsApi;
};

const UserSettingsContext = React.createContext<UserSettingsContextType | undefined>(
	undefined
);

export interface UserSettingsProviderProps {
	piletApi: PiletDataApi;
	pluginName: string;
	pluginBaseUrl: string;
	apiVersion?: string;
	children: React.ReactNode;
}

export const UserSettingsProvider: React.FC<UserSettingsProviderProps> = ({
	piletApi,
	pluginName,
	pluginBaseUrl,
	apiVersion = 'v1',
	children,
}) => {
	const api = React.useMemo(() => {
		return createPiletUserSettingsApi(piletApi, pluginName, pluginBaseUrl, apiVersion);
	}, [apiVersion, piletApi, pluginBaseUrl, pluginName]);

	// Init it in the fire and forget manner
	React.useEffect(() => {
		api.initializePluginSettings();
	}, [api]);

	return (
		<UserSettingsContext.Provider value={{ api }}>
			{children}
		</UserSettingsContext.Provider>
	);
};

export function useUserSettings() {
	const context = React.useContext(UserSettingsContext);
	if (!context) {
		throw new Error('useUserSettings must be used within a UserSettingsProvider');
	}

	return context;
}
